import { Paper } from "@mui/material";
import React from "react";

function SectionPaper({ children, sx }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 5,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        overflow: "hidden",
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
}

export default SectionPaper;
